import StimulusCarousel from '@stimulus-components/carousel'

export default class CarouselStimulusController extends StimulusCarousel {
  static values = {
    slidesPerView: Number,
    navigation: Boolean,
    autoHeight: Boolean,
    loop: Boolean,
    zoom: Boolean
  };

  static targets = [
    'swiperPagination',
    'swiperFractionPagination',
    'swiperButtonPrev',
    'swiperButtonNext',
  ];

  connect() {
    super.connect();

    this.swiper;

    this.defaultOptions;
  }

  get defaultOptions() {
    const navigationOptions = {
      nextEl: this.swiperButtonNextTarget,
      prevEl: this.swiperButtonPrevTarget,
    };

    if (this.hasSwiperFractionPaginationTarget) {
      this.paginationOptions = {
        el: this.swiperFractionPaginationTarget,
        type: 'fraction',
      }
    } else if (this.hasSwiperPaginationTarget) {
      this.paginationOptions = {
        el: this.swiperPaginationTarget,
        type: 'bullets',
        clickable: true,
      }
    } else {
      this.paginationOptions = false;
    }

    return {
      slidesPerView: this.slidesPerViewValue,
      navigation: this.navigationValue ? navigationOptions : false,
      loop: this.hasLoopValue ? this.loopValue : true,
      pagination: this.paginationOptions,
      autoHeight: this.autoHeightValue ? this.autoHeightValue : false,
      zoom: this.zoomValue ? this.zoomValue : false,
    };
  }

  customSlideTo(idx) {
    this.swiper.slideTo(idx, 0, false);
  }
}
